import axios from "axios";

const saveCompanyNote = async (token, content, companyId = null) => {
  try {
    const response = await axios.post(
      `${window.API}/company/${companyId}/note`,
      {
        content: content,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { result: response.data };
  } catch (error) {}
};

export { saveCompanyNote };
